import React from "react";
import "./OrchesWhat.css";
import img from "../orchesassets/orcheswhat.png";

export default function OrchesWhat() {
 
  return (
    <div id="orches-what" className="outsourcemainclass">
      <div className="right">
        <h2 className="heading">What Is DevOps Scalability?</h2>
        <p className="subheading">
         DevOps scalability is the practice of designing systems, applications, and infrastructure that can dynamically adapt to changing workloads. By combining automation, cloud-native technologies, and DevOps best practices, scalability ensures applications can grow or shrink based on demand, delivering consistent performance, high availability, and cost efficiency.
        </p>
        <button>Let's Discuss Your Project</button>
      </div>
         <div className="left">
        <img src={img} alt="error" />
      </div>
    </div>
  );
}
